import { aboutStats, pricingPillars } from '../mock';
import { Mountain } from 'lucide-react';
const AboutIntro = () => (
  <div className="lg:col-span-5">
    <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-[#3E5C76]">
      About Us
    </div>
    <h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium tracking-[-0.02em] text-[#0B2545]">
      Industry expertise.
      <br />
      <span className="text-slate-500">Modern technology.</span>
    </h2>
    <div className="mt-6 space-y-5 text-[15.5px] leading-relaxed text-slate-600 max-w-xl">
      <p>
        Northwest Title Alliance is a technology company built specifically for the
        Washington State title industry. We develop and license AI-powered tools that give
        title professionals access to capabilities that simply didn’t exist before — making
        them faster, more accurate, and more competitive.
      </p>
      <p>
        Our founding team brings decades of hands-on experience starting and operating
        title companies across Washington State. That depth of knowledge is baked directly
        into every product we build — not as an afterthought, but as the foundation.
      </p>
      <p>
        We’re not here to replace the industry. We’re here to arm it with tools that level
        the competitive landscape and push Washington title forward.
      </p>
    </div>
  </div>
);

const StatGrid = () => (
  <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
    {aboutStats.map((s) => (
      <div
        key={s.label}
        className="rounded-2xl bg-white border border-slate-200 p-6 hover:shadow-md hover:border-slate-300 transition-all"
      >
        <div className="font-serif text-5xl md:text-6xl font-semibold text-[#0B2545] tracking-tight">
          {s.value}
        </div>
        <div className="mt-2 text-[14px] font-semibold text-[#0B2545]">{s.label}</div>
        <div className="mt-1 text-[13px] text-slate-500 leading-relaxed">{s.sub}</div>
      </div>
    ))}
  </div>
);

const PricingPillars = () => (
  <div className="mt-24">
    <div className="flex items-center gap-3 text-[12px] uppercase tracking-[0.22em] font-semibold text-[#3E5C76]">
      <Mountain className="w-4 h-4" />
      ART Pricing
    </div>
    <h3 className="mt-3 font-serif text-3xl md:text-4xl font-medium tracking-[-0.01em] text-[#0B2545] max-w-2xl">
      Straightforward pricing, aligned with your success.
    </h3>
    <div className="mt-10 grid md:grid-cols-3 gap-5">
      {pricingPillars.map((p, i) => (
        <div
          key={p.title}
          className="relative rounded-2xl border border-slate-200 bg-white p-7 hover:-translate-y-0.5 hover:shadow-lg transition-all"
        >
          <div className="absolute top-6 right-6 text-[11px] font-semibold text-slate-400">
            0{i + 1}
          </div>
          <h4 className="font-serif text-2xl font-semibold text-[#0B2545] leading-tight max-w-[16ch]">
            {p.title}
          </h4>
          <p className="mt-4 text-[14.5px] leading-relaxed text-slate-600">{p.body}</p>
        </div>
      ))}
    </div>
  </div>
);

const About = () => (
  <section id="about" className="relative py-24 md:py-32 bg-[#F1F4F8]">
    <div className="absolute inset-0 topo-bg opacity-70 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12">
        <AboutIntro />
        <StatGrid />
      </div>
      <PricingPillars />
    </div>
  </section>
);

export default About;
